function showShare() {
    $('#pageShare__toggle').addClass('isActive');
    $('#pageShare__target').addClass('isActive');
}

function hideShare() {
    $('#pageShare__toggle').removeClass('isActive');
    $('#pageShare__target').removeClass('isActive');
}

$(function () {
    $('#pageShare__toggle').on('click', function () {
        if ($('#pageShare__target').hasClass('isActive')) {
            hideShare();
        } else {
            showShare();
            hideSearch();
            profileNav.close();
        }
    })
});